<section class="aq">
  <header class="aq-head">
    <h3>Needs your decision</h3>
    <span class="aq-sub" *ngIf="queue">The agent sorted these out of the pipeline</span>
    <button mat-icon-button (click)="load()" matTooltip="Refresh"><br-icon>refresh</br-icon></button>
  </header>

  <mat-progress-bar mode="indeterminate" *ngIf="loading"></mat-progress-bar>
  <div class="br-alert br-alert--danger aq-error" *ngIf="loadError"><br-icon>error_outline</br-icon> {{ loadError }}</div>

  <ng-container *ngIf="queue && !loadError">
    <div class="aq-filters" *ngIf="queue.total">
      <button type="button" class="br-btn br-btn--outline-secondary br-btn--sm aq-chip" [class.aq-chip-on]="kindFilter === null"
              (click)="setFilter(null)">All <b>{{ queue.total }}</b></button>
      <ng-container *ngFor="let f of filterKinds">
        <button type="button" class="br-btn br-btn--outline-secondary br-btn--sm aq-chip" *ngIf="countOf(f.kind)"
                [ngClass]="f.css" [class.aq-chip-on]="kindFilter === f.kind"
                (click)="setFilter(f.kind)">{{ f.label }} <b>{{ countOf(f.kind) }}</b></button>
      </ng-container>
    </div>

    <div class="br-alert br-alert--danger aq-error" *ngIf="actionError"><br-icon>block</br-icon> {{ actionError }}</div>

    <div class="aq-cards">
      <article class="aq-card" *ngFor="let card of items"
               [class.aq-go]="card.kind === 'StartPursuit'"
               [class.aq-rev]="card.kind === 'IdentityReview'"
               [class.aq-ag]="card.kind === 'Approval'"
               [class.aq-crit]="card.kind === 'GuardrailWarning'"
               [class.aq-ex]="card.kind === 'QuoteException'">
        <div class="aq-card-top">
          <span class="br-badge aq-kind">{{ kindLabel(card.kind) }}</span>
          <span class="aq-waiting" *ngIf="waitingDays(card) as days">{{ days }}d waiting</span>
        </div>

        <div class="aq-title">{{ card.title }}</div>
        <div class="aq-subtitle" *ngIf="card.subtitle">{{ card.subtitle }}</div>

        <!-- The evidence, as the server compared it: value beside the floor it
             is judged against, so the decision does not need another page. -->
        <dl class="aq-evidence" *ngIf="card.facts?.length">
          <div class="aq-ev" *ngFor="let fact of card.facts" [ngClass]="'aq-tone-' + (fact.tone || 'none')">
            <dt>{{ fact.label }}</dt>
            <dd>{{ fact.value }}</dd>
          </div>
        </dl>

        <p class="aq-reason"><span class="aq-who">AGENT</span>{{ card.reason }}</p>

        <!-- A decision the server will not take without a reason asks for it
             here rather than sending a placeholder into the audit trail. -->
        <div class="aq-ask" *ngIf="asking(card) as ask">
          <label [attr.for]="'aq-reason-' + cardKey(card)">
            {{ ask.verb === 'approveQuote'
                ? 'Why this price is worth an exception'
                : 'What needs to change before this can go out' }}
          </label>
          <textarea class="br-form-control br-form-control--sm" [id]="'aq-reason-' + cardKey(card)" rows="2" [(ngModel)]="reason"
                    placeholder="Recorded against the quote, with your name and the time"></textarea>
          <div class="aq-ask-actions">
            <button type="button" class="br-btn br-btn--primary br-btn--sm" [disabled]="!reason.trim()"
                    (click)="confirmQuote(card, ask.verb === 'approveQuote')">
              {{ ask.verb === 'approveQuote' ? 'Approve the exception' : 'Send it back' }}
            </button>
            <button type="button" class="br-btn br-btn--outline-secondary br-btn--sm" (click)="cancelAsk()">Cancel</button>
          </div>
        </div>

        <div class="aq-actions" *ngIf="!asking(card)">
          <!-- Taking a lead assigns it to you; it does not move its stage. -->
          <button type="button" class="br-btn br-btn--primary br-btn--sm" *ngIf="card.kind === 'StartPursuit'"
                  [disabled]="isBusy(card)" (click)="takeIt(card)"
                  matTooltip="Assign this lead to me">
            {{ isBusy(card) ? 'Taking…' : 'Take it' }}
          </button>

          <ng-container *ngIf="card.kind === 'IdentityReview'">
            <button type="button" class="br-btn br-btn--primary br-btn--sm" [disabled]="isBusy(card)" (click)="merge(card)">
              {{ isBusy(card) ? 'Merging…' : 'Same site — merge' }}
            </button>
            <button type="button" class="br-btn br-btn--outline-secondary br-btn--sm" [disabled]="isBusy(card)" (click)="keepSeparate(card)">
              Different businesses
            </button>
          </ng-container>

          <ng-container *ngIf="card.kind === 'QuoteException'">
            <button type="button" class="br-btn br-btn--primary br-btn--sm" [disabled]="isBusy(card)"
                    (click)="ask(card, { verb: 'approveQuote', needsReason: true })">
              {{ isBusy(card) ? 'Saving…' : 'Approve the exception' }}
            </button>
            <button type="button" class="br-btn br-btn--outline-secondary br-btn--sm" [disabled]="isBusy(card)"
                    (click)="ask(card, { verb: 'sendBackQuote', needsReason: true })">
              Send it back
            </button>
          </ng-container>

          <button type="button" class="br-btn br-btn--outline-secondary br-btn--sm" (click)="openCard(card)">{{ openLabel(card) }}</button>
        </div>
      </article>
    </div>

    <!-- Empty is the goal, not a failure: an inbox worked to the bottom says
         so, and lists what it checked. -->
    <div class="br-alert br-alert--success aq-clear" *ngIf="!queue.total">
      <br-icon>task_alt</br-icon>
      <div>
        <strong>Nothing waiting.</strong>
        <span>No qualified lead sitting unpursued, no uncertain match, no quote parked
          below the floor, no action held for approval.</span>
      </div>
    </div>
    <p class="aq-empty" *ngIf="queue.total && !items.length">
      No cards of that kind. <button type="button" class="br-btn br-btn--link br-btn--sm aq-link" (click)="setFilter(null)">Show all</button>
    </p>
  </ng-container>
</section>
